import { useState } from 'react';
import { Waypoints } from 'lucide-react';
import { ContactWebModal } from 'src/components/advisor-dashboard/professional-contacts/contact-web/contact-web-modal';
import { TrackedIconButton } from 'src/components/tracked';

type ContactWebLauncherProps = {
  readonly householdId: string | null | undefined;
};

export function ContactWebLauncher({ householdId }: ContactWebLauncherProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TrackedIconButton
        size="sm"
        variant="secondary"
        elementName="household-header-contact-web-button"
        aria-label="View contact web"
        onClick={() => setOpen(true)}
      >
        <Waypoints />
      </TrackedIconButton>
      <ContactWebModal open={open} onOpenChange={setOpen} focusHouseholdId={householdId ?? undefined} />
    </>
  );
}
